<script lang="ts">
  import { onMount } from "svelte";
  import LoadingIndicator from "./LoadingIndicator.svelte";
  import { getGiftPreview } from "../lib/apiLoader/campaign";
  import { getAllSearchParams } from "../lib/helpers/document";
  import VerticalMenuItemCard from "./Menu/VerticalMenuItemCard.svelte";
  import type { MenuItem } from "../lib/helpers/steps/menuItems";

  let isLoading = true;
  let item: MenuItem;

  onMount(async () => {
    const { i: itemKey, v: variation } = getAllSearchParams();
    try {
      const { gift } = await getGiftPreview({ itemKey, variation });
      item = {
        visible_name: gift.visible_name,
        description: gift.description,
        image: gift.image,
        variations: [],
        order: 0,
        name: gift.visible_name
      };
      isLoading = false;
    } catch (error) {
      console.error("Failed to fetch gift preview", error);
    }
  });
</script>

<div>
  <div class="w-full flex justify-center mt-8">
    {#if isLoading}
      <LoadingIndicator />
    {:else}
      <VerticalMenuItemCard {item} />
    {/if}
  </div>
</div>
